import { IGalleryState } from "./interfaces";

export const DEFAULT_POI_GALLERY_IND = -1;

export const DEFAULT_GALLERY_STATE: IGalleryState = {
	poiGalleryInd: DEFAULT_POI_GALLERY_IND,
	poiGallery: [],
};
